import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Polling fallback for live screens: if the websocket broadcast is missed,
// the page still re-syncs (via a Turbo morph refresh) every few seconds.
export default class extends Controller {
  static values = { interval: { type: Number, default: 20000 } }

  connect() {
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  refresh() {
    if (document.hidden) return
    // Don't disturb someone typing or paying.
    if (document.querySelector(".modal.show")) return
    const active = document.activeElement
    if (active && ["INPUT", "TEXTAREA", "SELECT"].includes(active.tagName)) return

    Turbo.session.refresh(window.location.href)
  }
}
